/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { LoginIdPasswordParametersModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class LoginParametersClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags LoginParameters
   * @name LoginParametersGet
   * @summary Provides the Login parameter for the specified type.
   * @request GET:/loginParameters
   */
  loginParametersGet = (
    query?: {
      /** Parameters for FI company or FI. */
      type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<LoginIdPasswordParametersModelDto, any>({
      path: `/loginParameters`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LoginParameters
   * @name LoginParametersPost
   * @summary Adds the passed Login parameter.
   * @request POST:/loginParameters
   */
  loginParametersPost = (
    data: LoginIdPasswordParametersModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<LoginIdPasswordParametersModelDto, any>({
      path: `/loginParameters`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LoginParameters
   * @name LoginParametersPut
   * @summary Updates the modifed login parameter.
   * @request PUT:/loginParameters/{id}
   */
  loginParametersPut = (
    id: number,
    data: LoginIdPasswordParametersModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<LoginIdPasswordParametersModelDto, any>({
      path: `/loginParameters/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LoginParameters
   * @name LoginParametersDefaults
   * @summary Provides the Login parameter for the specified type.
   * @request GET:/loginParameters/{id}/defaults
   */
  loginParametersDefaults = (
    id: number,
    query?: {
      isCompanyParameter?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<LoginIdPasswordParametersModelDto, any>({
      path: `/loginParameters/${id}/defaults`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
